<div class="row">
  <div class="col-sm-6 no-print">
    <div>
      <div class="margin-bottom">
        <!--<button class="btn btn-second" (click)="recalculateArray()">-->
        <!--<i class="fa fa-spinner margin-right"></i>-->
        <!--{{'print.confirmSelected' | trans}}-->
        <!--</button>-->
        @if (pageCount > 1) {
          <div>
            <strong>{{ 'print.page.select.warn' | translate }} {{ pageCount }}</strong>
          </div>
        }
        @if (pageCount > 1) {
          <form-row-input
            [label]="'print.page.select'"
            [icon]="'fa-file'"
            [inputType]="'number'"
            [(model)]="pageSelected"
            (valueChangeNative)="recalculateArray()"
          ></form-row-input>
        }
        @if (pageCount > 1) {
          <btn
            [classes]="['btn-secondary', 'btn']"
            [icon]="'fa-chevron-down'"
            (onEvent)="pageDown($event)"
            [btnDisabled]="pageSelected <= 1"
          ></btn>
        }
        @if (pageCount > 1) {
          <btn
            [classes]="['btn-secondary', 'btn', 'margin-right']"
            [icon]="'fa-chevron-up'"
            (onEvent)="pageUp($event)"
            [btnDisabled]="pageSelected >= pageCount"
          ></btn>
        }
        <button class="btn btn-primary" (click)="confirmPreview()">
          <i class="fa fa-print margin-right"></i>
          {{ 'print' | translate }}
        </button>
      </div>
      <div>
        <form-row-input
          [label]="'page.margin.top'"
          [icon]="'fa-arrow-up'"
          [inputType]="'number'"
          [(model)]="pageMarginTop"
          (valueChangeNative)="recalculateArray()"
        ></form-row-input>
        <form-row-input
          [label]="'page.margin.left'"
          [icon]="'far-arrow-left'"
          [inputType]="'number'"
          [(model)]="pageMarginLeft"
          (valueChangeNative)="recalculateArray()"
        ></form-row-input>
        <form-row-input
          [label]="'barcode.padding.horizontal'"
          [icon]="'fa-arrows-h'"
          [inputType]="'number'"
          [(model)]="barcodePaddingHorizontal"
          (valueChangeNative)="recalculateArray()"
        ></form-row-input>
        <form-row-input
          [label]="'barcode.padding.vertical'"
          [icon]="'fa-arrows-v'"
          [inputType]="'number'"
          [(model)]="barcodePaddingVertical"
          (valueChangeNative)="recalculateArray()"
        ></form-row-input>
        <button
          class="btn btn-default margin-right"
          style="margin-bottom: 1rem"
          [ngClass]="{ 'btn-second': barcodeTitleVisible }"
          (click)="toggleBarcodeTitleVisible()"
        >
          {{ 'barcode.title' | translate }}
        </button>
        <br /><button
          class="btn btn-default margin-right"
          style="margin-bottom: 1rem"
          [ngClass]="{ 'btn-second': barcodeEanVisible }"
          (click)="toggleBarcodeEanVisible()"
        >
          {{ 'barcode.ean' | translate }}
        </button>
        <br /><button
          class="btn btn-default margin-right"
          style="margin-bottom: 1rem"
          [ngClass]="{ 'btn-second': barcodePriceVisible }"
          (click)="toggleBarcodePriceVisible()"
        >
          {{ 'barcode.price' | translate }}
        </button>
        <br /><button
          class="btn btn-default margin-right"
          style="margin-bottom: 1rem"
          [ngClass]="{ 'btn-second': barcodeWidth }"
          (click)="toggleBarcodeWidth()"
        >
          {{ 'barcode.width' | translate }}
        </button>
        <btn
          [classes]="[oneTicket ? 'btn-second' : 'btn-third']"
          (onEvent)="toggleOneTicketMode()"
          [label]="'barcode.one'"
          [title]="'barcode.one' | translate"
        ></btn>
      </div>
      <div style="visibility: hidden">
        <!--<h3 class="margin-bottom">{{'preview' | trans}}</h3>-->
        <div>
          <canvas #barcode id="barcode"></canvas>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    @if (loading) {
      <div class="no-print">
        <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      </div>
    }
    <div>
      <div class="barcode-array-container-margin" #printable id="printable">
        @if (oneTicket) {
          <div
            class="barcode-array-container"
            [style.marginTop]="pageMarginTop + 'mm'"
            [style.marginBottom]="-1 * pageMarginTop + 'mm'"
            [style.marginLeft]="pageMarginLeft + 'mm'"
            [style.marginRight]="-1 * pageMarginLeft + 'mm'"
          >
            <div
              class="barcode-array-item one-ticket"
              [style.paddingTop]="barcodePaddingVertical + 'mm'"
              [style.paddingBottom]="barcodePaddingVertical + 'mm'"
              [style.paddingLeft]="barcodePaddingHorizontal + 'mm'"
              [style.paddingRight]="barcodePaddingHorizontal + 'mm'"
            >
              <div class="one-ticket-row">
                <div class="one-ticket-item-title">
                  {{ barcodeTitleVisible ? printArray[0].fullName : '&nbsp;' }}
                </div>
              </div>
              <div class="one-ticket-row">
                @if (printArray[0].val && printArray[0].val.length > 0) {
                  <img [src]="printArray[0].val" alt="" class="one-ticket-item-img" />
                }
                <div class="one-ticket-item-size">&nbsp;</div>
              </div>
              @if (printArray[0].val && printArray[0].val.length > 0) {
                <div class="one-ticket-row">
                  <div class="one-ticket-item-ean">
                    {{ barcodeEanVisible ? printArray[0].ean : '&nbsp;' }}
                    <br />
                    {{ barcodeEanVisible ? printArray[0].code : '&nbsp;' }}
                  </div>
                  <div class="d-flex flex-column" style="margin-top: -1mm">
                    @if (barcodePriceVisible && printArray[0].beforeSellPrice > 0) {
                      <div class="one-ticket-item-price before-sell-price">
                        {{ printArray[0].beforeSellPrice | formatPrice }}
                      </div>
                    }
                    <div class="one-ticket-item-price">
                      {{ barcodePriceVisible ? (printArray[0].sellPrice | formatPrice) : '&nbsp;' }}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (!oneTicket) {
          <div
            class="barcode-array-container"
            [style.marginTop]="pageMarginTop + 'mm'"
            [style.marginBottom]="-1 * pageMarginTop + 'mm'"
            [style.marginLeft]="pageMarginLeft + 'mm'"
            [style.marginRight]="-1 * pageMarginLeft + 'mm'"
          >
            @for (barcode of printArray; track barcode) {
              <div
                class="barcode-array-item"
                (click)="updateStartAt(barcode)"
                [style.paddingTop]="barcodePaddingVertical + 'mm'"
                [style.paddingBottom]="barcodePaddingVertical + 'mm'"
                [style.paddingLeft]="barcodePaddingHorizontal + 'mm'"
                [style.paddingRight]="barcodePaddingHorizontal + 'mm'"
              >
                @if (barcode.val && barcode.val.length > 0) {
                  <div class="barcode-array-item-title">
                    {{ barcodeTitleVisible ? barcode.fullName : '&nbsp;' }}
                  </div>
                }
                @if (barcode.val && barcode.val.length > 0) {
                  <img [src]="barcode.val" alt="" class="barcode-array-item-img" />
                }
                @if (barcode.val && barcode.val.length > 0) {
                  <div class="barcode-array-item-bottom-line">
                    <div class="barcode-array-item-ean">{{ barcodeEanVisible ? barcode.ean : '&nbsp;' }}</div>
                    <div class="barcode-array-item-price">
                      {{
                        barcodePriceVisible
                          ? (barcode.sellPrice | formatPrice: core.services.user?.user?.company?.currency)
                          : '&nbsp;'
                      }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div
  id="html2canvas-container"
  class="barcode-array-container is-printing"
  [style.marginTop]="pageMarginTop + 'mm'"
  [style.marginBottom]="-1 * pageMarginTop + 'mm'"
  [style.marginLeft]="pageMarginLeft + 'mm'"
  [style.marginRight]="-1 * pageMarginLeft + 'mm'"
>
  @for (barcode of printArray; track barcode) {
    <div
      class="barcode-array-item"
      (click)="updateStartAt(barcode)"
      [style.paddingTop]="barcodePaddingVertical + 'mm'"
      [style.paddingBottom]="barcodePaddingVertical + 'mm'"
      [style.paddingLeft]="barcodePaddingHorizontal + 'mm'"
      [style.paddingRight]="barcodePaddingHorizontal + 'mm'"
    >
      @if (barcode.val && barcode.val.length > 0) {
        <div class="barcode-array-item-title">
          {{ barcodeTitleVisible ? barcode.fullName : '&nbsp;' }}
        </div>
      }
      @if (barcode.val && barcode.val.length > 0) {
        <img [src]="barcode.val" alt="" class="barcode-array-item-img" />
      }
      @if (barcode.val && barcode.val.length > 0) {
        <div class="barcode-array-item-bottom-line">
          <div class="barcode-array-item-ean">{{ barcodeEanVisible ? barcode.ean : '&nbsp;' }}</div>
          <div class="barcode-array-item-price">
            {{
              barcodePriceVisible
                ? (barcode.sellPrice | formatPrice: core.services.user?.user?.company?.currency)
                : '&nbsp;'
            }}
          </div>
        </div>
      }
    </div>
  }
</div>
